import type { ComponentProps } from "react";
import { tv, type VariantProps } from "tailwind-variants";

import { cn } from "@/lib/utils";

export const inputVariants = tv({
  base: "placeholder:text-foreground-pressed text-foreground interactive w-full min-w-0 text-sm",
  variants: {
    size: {
      lg: "h-11",
      md: "h-10",
      sm: "h-9",
    },
    variant: {
      ghost: "flex bg-transparent outline-hidden",
      default:
        "bg-background-neutral border-background-neutral-hovered rounded-md border px-3 py-2 shadow-xs file:text-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium aria-invalid:ring-critical/20 aria-invalid:border-critical",
    },
  },
  defaultVariants: {
    size: "md",
    variant: "default",
  },
});

export type InputVariants = VariantProps<typeof inputVariants>;

export default function Input({
  type,
  size = "md",
  className,
  ...props
}: Omit<ComponentProps<"input">, "size"> & Pick<InputVariants, "size">) {
  return (
    <input
      type={type}
      data-slot="input"
      data-size={size}
      className={cn(inputVariants({ size, variant: "default" }), className)}
      {...props}
    />
  );
}
